export default __webpack_public_path__ + "static/media/IMG_4047.537404da.JPG";